import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import gsap from 'gsap';
import { MotionPathPlugin } from 'gsap/MotionPathPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import SlideUp from "./SlideUp";

// Register GSAP plugins
gsap.registerPlugin(MotionPathPlugin, ScrollTrigger);

const ScreenUpDown = ({ props }) => {
  const imgRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {

    if (!imgRef.current) return;
    const imageEl = imgRef.current;
    const originalSrc = require(`../../assets/images/screen/${props.imgName}`);
    const newSrc = require(`../../assets/images/screen/ios-ivisita.avif`); // Or any other fallback/replacement image
    const isRTL = typeof window !== 'undefined' && document?.dir === 'rtl';

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: imageEl,
        start: "top+=200 center",
        scrub: true,
        // markers: true,
        onUpdate: (self) => {
          if (self.progress > 0.65) {
            // Enter second stage - change src
            if (imageEl.src !== newSrc) imageEl.src = newSrc;
          } else {
            // Revert to original
            if (imageEl.src !== originalSrc) imageEl.src = originalSrc;
          }
        },
      },
    });

    // console.log(window.innerWidth)
    const largeScreenPlacement = isRTL ? { x: 600, y: 750 } : { x: -600, y: 750 } // { x: -730, y: 730 }
    // const smallScreenPlacement = { x: -600, y: 750 }
    let animationPlacement;
    animationPlacement = window.innerWidth >= 700 ? largeScreenPlacement : {}
    tl.to(imageEl, {
      duration: 0.5,
      // scale: 0.8,
      motionPath: {
        path: [
          animationPlacement
        ],
        curviness: 1,
      },
      ease: "none",
    });
    return () => {
      tl.kill();
      ScrollTrigger.getById(tl?.scrollTrigger?.id)?.kill();
    };
  }, [props]);

  return (
    <div className="md:w-theme-container w-mobile-container md:pt-32 md:pb-40 mx-auto">
      <div
        className={`grid grid-cols-1 md:grid-cols-2 md:gap-8 md:mb-0 mb-20 ${
          props.position === 0
            ? 'md:[&>*:nth-child(1)]:order-2 md:[&>*:nth-child(2)]:order-1'
            : ''
        }`}
      >
        <div className="w-full flex justify-center items-center">
          <div className="md:w-60 w-44">
            {(() => {
              const isLargeScreen = window.innerWidth >= 700;
              const isSpecialItem = props?.id === 1;

              if (isLargeScreen && isSpecialItem) {
                return (
                  <img
                    ref={imgRef}
                    className="w-full"
                    src={require(`../../assets/images/screen/${props.imgName}`)}
                    alt={props.title || 'Feature image'}
                  />
                );
              }

              if (!isLargeScreen) {
                return (
                  <SlideUp>
                    <img
                      className="w-full"
                      src={require(`../../assets/images/screen/${props.imgName}`)}
                      alt={props.title || 'Feature image'}
                    />
                  </SlideUp>
                );
              }
              // Default return if none of the above conditions match
              return null;
            })()}
          </div>
        </div>
        <div className="flex flex-col justify-center text-center">
          <SlideUp>
            <div className="md:text-2xl text-xl my-5">{t(`portfolioInfo.titles.${props?.id-1}`)}</div>
            {/*<div className="md:text-2xl text-xl my-5">{}</div>*/}
          </SlideUp>
          <SlideUp>
            <div className="md:text-xl text-justify text-base mt-10">{t(`portfolioInfo.descriptions.${props?.id-1}`)}</div>
          </SlideUp>
        </div>
      </div>
    </div>
  );
};

export default ScreenUpDown;
